require('./bootstrap');
import $ from 'jquery';
window.$ = window.jQuery = $;
import "jquery-datetimepicker";
// import 'jquery-ui/ui/widgets/datepicker.js';

$(document).ready(function () {
        $('#sidebarCollapse').on('click', function () {
                    $('#sidebar').toggleClass('active');

        });

       var id_contariner = "";

       $("#container").autocomplete({
          /*source: availableCursos*/
                source: function( request, response ) {
    	        $.ajax( {
    	          url: "/search/buscar_containers",
    	          dataType: "json",
    	          data: {
    	            term: request.term
    	          },
    	          success: function( data ) {
                      response( data );
                      // alert(JSON.stringify(data));
                  }

    	        } );
    	      },
               select: function( event,ui )
               {
               	   id_contariner = ui.item.id;
                   $("#container_id").val(ui.item.id);
                   $("#container").val(ui.item.value);
                   return false;
               },
               change: function (event,ui){
                   $("#container_id").val(ui.item? ui.item.id:null);

               }
        });

        $("#traspaso_tatc_movimiento").change(function() {
         var movimiento = $("#traspaso_tatc_movimiento option:selected").text();

           if(movimiento === ""){

           }else{
              if(movimiento === "Compra"){


    	       }else{
    	         if(movimiento === "Venta"){

    		       }else{
    		         alert("Verificar con administrador");
    		       }
    	       }
           }
        });


        $( ".tatc-origen" ).autocomplete({
    		        /*source: availableCursos*/
    		        source: function( request, response ) {
    		            $.ajax( {
    		                url: "/search/buscar_tatc",
    		                dataType: "json",
    		                data: {
    		                    term: request.term
    		                },
    		                success: function( data ) {
    		                    response( data );
    		                    // alert(data);
    		                }
    		            } );
    		        }
    		        ,
    		        select: function( event,ui )
    		         {
    		             $("#origen_tatc").val(ui.item.id);
    		             $("#traspaso_tatc_origen").val(ui.item.value);
    		             $("#ingreso_tatc_num").val(ui.item.value);
                         $("#ingreso_tatc_fec_emi").val(ui.item.fec_emi);
    		             return false;
    		         },
    		        change: function (event,ui){
    		             $("#origen_tatc").val(ui.item? ui.item.id:null);
    		         }

        });// Final ready

        $( ".tstc-origen" ).autocomplete({
    		        /*source: availableCursos*/
    		        source: function( request, response ) {
    		            $.ajax( {
    		                url: "/search/buscar_tstc",
    		                dataType: "json",
    		                data: {
    		                    term: request.term
    		                },
    		                success: function( data ) {
    		                    response( data );
    		                    // alert(data);
    		                }
    		            } );
    		        }
    		        ,
    		        select: function( event,ui )
    		         {
    		             $("#origen_tstc").val(ui.item.id);
    		             $("#salida_tstc_num").val(ui.item.value);
                         $("#salida_tstc_fec_emi").val(ui.item.fec_emi);
    		             return false;
    		         },
    		        change: function (event,ui){
    		             $("#origen_tstc").val(ui.item? ui.item.id:null);
    		         }
    	  });

    	  $( ".tatc-destino" ).autocomplete({
    		        /*source: availableCursos*/
    		        source: function( request, response ) {
    		            $.ajax( {
    		                url: "/search/buscar_tatc",
    		                dataType: "json",
    		                data: {
    		                    term: request.term
    		                },
    		                success: function( data ) {
    		                    response( data );
    		                    // alert(data);
    		                }
    		            } );
    		        }
    		        ,
    		        select: function( event,ui )
    		         {
    		             $("#destino_tatc").val(ui.item.id);
    		             $("#traspaso_tatc_destino").val(ui.item.value);


    		             return false;
    		         },
    		        change: function (event,ui){
    		             $("#destino_tatc").val(ui.item? ui.item.id:null);
    		         }
    	  });



        $(".deposito").autocomplete({
            /*source: availableCursos*/
            source: function( request, response ) {
                $.ajax( {
                    url: "/search/buscar_dep",
                    dataType: "json",
                    data: {
                        term: request.term
                    },
                    success: function( data ) {
                        response( data );
                    }
                } );
            }
        });

        $(".operador").autocomplete({
            /*source: availableCursos*/
            source: function( request, response ) {
                $.ajax( {
                    url: "/search/buscar_op",
                    dataType: "json",
                    data: {
                        term: request.term
                    },
                    success: function( data ) {
                        response( data );
                    }
                } );
            }
        });

        $("#tatc_estado").change(function() {
         	var element_seleccionado = $(this).val();

         	if(element_seleccionado === "CANCELADO")
         	{
            	$("#tatc_codigo_cancelacion").prop('disabled', false);
            	$("#tatc_codigo_can_detalle").prop('readonly', false);

         	}else{

            $("#tatc_codigo_cancelacion option[value='seleccionar']").attr("selected",true);
         		$("#tatc_codigo_can_detalle").val("");
         		$("#tatc_codigo_cancelacion").prop('disabled', true);
         		$("#tatc_codigo_can_detalle").prop('readonly', true);
         	}
        });

        $("#tstc_estado").change(function() {
          var element_seleccionado = $(this).val();

          if(element_seleccionado === "CANCELADO")
          {
              $("#tstc_codigo_cancelacion").prop('disabled', false);
              $("#tstc_codigo_can_detalle").prop('readonly', false);

          }else{

            $("#tstc_codigo_cancelacion option[value='seleccionar']").attr("selected",true);
            $("#tstc_codigo_can_detalle").val("");
            $("#tstc_codigo_cancelacion").prop('disabled', true);
            $("#tstc_codigo_can_detalle").prop('readonly', true);
          }
        });


        $('#traspaso_fecha').datetimepicker();
        // $('#ingreso_tatc_fec_emi').datetimepicker();
        $('#ingreso_tatc_fec_emi').prop('readonly',true);
        $('#ingreso_tatc_fec_pais').datetimepicker();
        $('#ingreso_tatc_fec_recinto').datetimepicker();
        $('#salida_tstc_fec_emi').prop('readonly',true);
        $('#salida_tstc_fec_pais').datetimepicker();
        $('#salida_tstc_fec_ingreso_recinto').datetimepicker();

        $('#reporte_contenedores').DataTable( {
          responsive: true,
          autoWidth:false,
            "language": {
                "lengthMenu": "Mostrar _MENU_ registros por página",
                "zeroRecords": "Sin registros encontrados",
                "info": "Mostrando la página _PAGE_ de _PAGES_",
                "infoEmpty": "No records available",
                "infoFiltered": "(filtrado de _MAX_ registros totales)",
                "search": "Buscar",
                "paginate":{
                  "next":"Siguiente",
                  "previous":"Anterior"
                },


            },
            dom: 'Bfrtip',
            buttons: [
             {
                 extend: 'excel',
                 title: 'Reporte Detalle Container',
                  exportOptions: {
                      columns: "thead th:not(.noExport)"
                  }
             },
             {
                 extend: 'csv',


             }]
        } );

        $('#reporte_ingreso_tatc').DataTable( {
          responsive: true,
          autoWidth:false,
            "language": {
                "lengthMenu": "Mostrar _MENU_ registros por página",
                "zeroRecords": "Sin registros encontrados",
                "info": "Mostrando la página _PAGE_ de _PAGES_",
                "infoEmpty": "No records available",
                "infoFiltered": "(filtrado de _MAX_ registros totales)",
                "search": "Buscar",
                "paginate":{
                  "next":"Siguiente",
                  "previous":"Anterior"
                },


            },
            dom: 'Bfrtip',
            buttons: [
             {
                 extend: 'excel',
                 title: 'Reporte Ingreso TATC',
                  exportOptions: {
                      columns: "thead th:not(.noExport)"
                  }
             },
             {
                 extend: 'csv',


             }]
        } );

        $('#reporte_salida_tstc').DataTable( {
          responsive: true,
          autoWidth:false,
            "language": {
                "lengthMenu": "Mostrar _MENU_ registros por página",
                "zeroRecords": "Sin registros encontrados",
                "info": "Mostrando la página _PAGE_ de _PAGES_",
                "infoEmpty": "No records available",
                "infoFiltered": "(filtrado de _MAX_ registros totales)",
                "search": "Buscar",
                "paginate":{
                  "next":"Siguiente",
                  "previous":"Anterior"
                },


            },
            dom: 'Bfrtip',
            buttons: [
             {
                 extend: 'excel',
                 title: 'Reporte Salida TSTC',
                  exportOptions: {
                      columns: "thead th:not(.noExport)"
                  }
             },
             {
                 extend: 'csv',


             }]
        } );

        $('#reporte_registro_tatc').DataTable( {
          responsive: true,
          autoWidth:false,
            "language": {
                "lengthMenu": "Mostrar _MENU_ registros por página",
                "zeroRecords": "Sin registros encontrados",
                "info": "Mostrando la página _PAGE_ de _PAGES_",
                "infoEmpty": "No records available",
                "infoFiltered": "(filtrado de _MAX_ registros totales)",
                "search": "Buscar",
                "paginate":{
                  "next":"Siguiente",
                  "previous":"Anterior"
                },


            },
            dom: 'Bfrtip',
            buttons: [
             {
                 extend: 'excel',
                 title: 'Reporte Historial TATCs',
                  exportOptions: {
                      columns: "thead th:not(.noExport)"
                  }
             },
             {
                 extend: 'csv',


             }]
        } );

        $('#reporte_registro_tstc').DataTable( {
          responsive: true,
          autoWidth:false,
            "language": {
                "lengthMenu": "Mostrar _MENU_ registros por página",
                "zeroRecords": "Sin registros encontrados",
                "info": "Mostrando la página _PAGE_ de _PAGES_",
                "infoEmpty": "No records available",
                "infoFiltered": "(filtrado de _MAX_ registros totales)",
                "search": "Buscar",
                "paginate":{
                  "next":"Siguiente",
                  "previous":"Anterior"
                },


            },
            dom: 'Bfrtip',
            buttons: [
             {
                 extend: 'excel',
                 title: 'Reporte Historial TSTCs',
                  exportOptions: {
                      columns: "thead th:not(.noExport)"
                  }
             },
             {
                 extend: 'csv',


             }]
        } );

        $('#reporte_tatc').DataTable( {
          responsive: true,
          autoWidth:false,
            "language": {
                "lengthMenu": "Mostrar _MENU_ registros por página",
                "zeroRecords": "Sin registros encontrados",
                "info": "Mostrando la página _PAGE_ de _PAGES_",
                "infoEmpty": "No records available",
                "infoFiltered": "(filtrado de _MAX_ registros totales)",
                "search": "Buscar",
                "paginate":{
                  "next":"Siguiente",
                  "previous":"Anterior"
                },


            },
            dom: 'Bfrtip',
            buttons: [
             {
                 extend: 'excel',
                 title: 'Reporte TATCs',
                  exportOptions: {
                      columns: "thead th:not(.noExport)"
                  }
             },
             {
                 extend: 'csv',


             }]
        } );

        $('#reporte_traspaso').DataTable( {
          responsive: true,
          autoWidth:false,
            "language": {
                "lengthMenu": "Mostrar _MENU_ registros por página",
                "zeroRecords": "Sin registros encontrados",
                "info": "Mostrando la página _PAGE_ de _PAGES_",
                "infoEmpty": "No records available",
                "infoFiltered": "(filtrado de _MAX_ registros totales)",
                "search": "Buscar",
                "paginate":{
                  "next":"Siguiente",
                  "previous":"Anterior"
                },


            },
            dom: 'Bfrtip',
            buttons: [
             {
                 extend: 'excel',
                 title: 'Reporte Traspasos',
                  exportOptions: {
                      columns: "thead th:not(.noExport)"
                  }
             },
             {
                 extend: 'csv',


             }]
        } );

        $('#reporte_tstc').DataTable( {
          responsive: true,
          autoWidth:false,
            "language": {
                "lengthMenu": "Mostrar _MENU_ registros por página",
                "zeroRecords": "Sin registros encontrados",
                "info": "Mostrando la página _PAGE_ de _PAGES_",
                "infoEmpty": "No records available",
                "infoFiltered": "(filtrado de _MAX_ registros totales)",
                "search": "Buscar",
                "paginate":{
                  "next":"Siguiente",
                  "previous":"Anterior"
                },


            },
            dom: 'Bfrtip',
            buttons: [
             {
                 extend: 'excel',
                 title: 'Reporte TSTCs',
                  exportOptions: {
                      columns: "thead th:not(.noExport)"
                  }
             },
             {
                 extend: 'csv',


             }]
        } );

        $(".valida_numero").bind('keypress', function(event) {
          var regex = new RegExp("^[0-9]+$");
          var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
          if (!regex.test(key)) {
            event.preventDefault();
            return false;
          }
        });

        $(".valida_numero_decimal").bind('keypress', function(event) {
          var regex = new RegExp("^[0-9\.]+$");
          var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
          if (!regex.test(key)) {
            event.preventDefault();
            return false;
          }
        });

        $(".valida_letra").bind('keypress', function(event) {
        var regex = new RegExp("^[a-zA-Z ]+$");
        var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
        if (!regex.test(key)) {
          event.preventDefault();
          return false;
        }
        });

        $(".valida_alfanumerico").bind('keypress', function(event) {
          var regex = new RegExp("^[a-zA-Z0-9\- ]+$");
          var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
          if (!regex.test(key)) {
            event.preventDefault();
            return false;
         }
        });

        $(".valida_rut").bind('keypress', function(event) {
          var regex = new RegExp("^[a-zA-Z0-9\- ]+$");
          /*  ^\d{1,2}\.\d{3}\.\d{3}[-][0-9kK]{1}$*/
          var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
          if (!regex.test(key)) {
            event.preventDefault();
            return false;
         }
        });



       $("#container_nac").change(function() {
        if(this.checked) {
          $("#container_nac_doc").css("display","block");
        }else{

          $("#container_nac_doc").css("display","none");
        }
       });

       /*

        const labels1 = [
          'EMITIDO',
          'VIGENTE',
          'PRORROGA',
          'CANCELADO',
          'VENCIDO',
        ];

        var can_tatc_emitido = $('#cant_tatc_emitido').text();
        var can_tatc_vigente = $('#cant_tatc_vigente').text();
        var can_tatc_prorroga = $('#cant_tatc_prorroga').text();
        var can_tatc_cancelado = $('#cant_tatc_cancelado').text();
        var can_tatc_vencido = $('#cant_tatc_vencido').text();

        const data1 = {
          labels: labels1,
          datasets: [{
            label: 'Cantidad Estados TATCs',
            backgroundColor: 'rgba(255, 159, 64, 0.2)',
            borderColor: 'rgb(255, 99, 132)',
            data: [can_tatc_emitido, can_tatc_vigente, can_tatc_prorroga, can_tatc_cancelado, can_tatc_vencido],
          }]
        };
        const config1 = {
          type: 'line',
          data: data1,
          options: {}
        };

        const myChart1 = new Chart(
          document.getElementById('myChart1'),
          config1
        );

        const labels2 = [
          'EMITIDO',
          'VIGENTE',
          'PRORROGA',
          'CANCELADO',
          'VENCIDO',
        ];

        var can_tstc_emitido = $('#cant_tstc_emitido').text();
        var can_tstc_vigente = $('#cant_tstc_vigente').text();
        var can_tstc_prorroga = $('#cant_tstc_prorroga').text();
        var can_tstc_cancelado = $('#cant_tstc_cancelado').text();
        var can_tstc_vencido = $('#cant_tstc_vencido').text();

        const data2 = {
          labels: labels2,
          datasets: [{
            label: 'Cantidad Estados TSTCs',
            data: [can_tstc_emitido, can_tstc_vigente, can_tstc_prorroga, can_tstc_cancelado, can_tstc_vencido],
            fill: false,
            borderColor: 'rgb(75, 192, 192)',
            tension: 0.1
          }]
        };

        const config2 = {
          type: 'line',
          data: data2,
        };

        const myChart2 = new Chart(
          document.getElementById('myChart2'),
          config2
        );

        const labels = [
          '20 Dry',
          '20 Reefer',
          '40 Dry Std',
          '40 Dry Hc',
          '40 Reefer',
        ];

        var cant_cont_20dry = $('#cant_cont_20dry').text();
        var cant_cont_20Reefer = $('#cant_cont_20Reefer').text();
        var cant_cont_40drystd = $('#cant_cont_40drystd').text();
        var cant_cont_40dryHc = $('#cant_cont_40dryHc').text();
        var cant_cont_40Reefer = $('#cant_cont_40Reefer').text();

        const data = {
          labels: labels,
          datasets: [{
            label: 'Tipos Conatiner',
            data: [cant_cont_20dry, cant_cont_20Reefer, cant_cont_40drystd, cant_cont_40dryHc, cant_cont_40Reefer],
            backgroundColor: [
              'rgba(255, 99, 132, 0.2)',
              'rgba(255, 159, 64, 0.2)',
              'rgba(255, 205, 86, 0.2)',
              'rgba(75, 192, 192, 0.2)',
              'rgba(54, 162, 235, 0.2)',
              'rgba(153, 102, 255, 0.2)',
              'rgba(201, 203, 207, 0.2)'
            ],
            borderColor: [
              'rgb(255, 99, 132)',
              'rgb(255, 159, 64)',
              'rgb(255, 205, 86)',
              'rgb(75, 192, 192)',
              'rgb(54, 162, 235)',
              'rgb(153, 102, 255)',
              'rgb(201, 203, 207)'
            ],
            borderWidth: 1
          }]
        };


        const config = {
          type: 'bar',
          data: data,
          options: {
            scales: {
              y: {
                beginAtZero: true
              }
            }
          },
        };

        const myChart = new Chart(
          document.getElementById('myChart'),
          config
        );

        var cant_tras_compra = $('#cant_tras_compra').text();
        var cant_tras_venta = $('#cant_tras_venta').text();

        const data3 = {
          labels: [
            'Compra',
            'Venta'
          ],
          datasets: [{
            label: 'Movimiento Traspaso',
            data: [cant_tras_compra, cant_tras_venta],
            backgroundColor: [
              'rgb(75, 192, 192)',
              'rgb(255, 205, 86)'
            ],
            hoverOffset: 4
          }]
        };



        const config3 = {
          type: 'pie',
          data: data3,
        };

        const myChart3 = new Chart(
          document.getElementById('myChart3'),
          config3
        );
        */
       /*
        const labels4 = [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
        ];
        const data4 = {
          labels: labels4,
          datasets: [{
            label: 'My First dataset',
            backgroundColor: 'rgba(255, 205, 86, 0.2)',
            borderColor: 'rgb(255, 205, 86)',
            data: [0, 10, 5, 2, 20, 30, 45],
          }]
        };
        const config4 = {
          type: 'line',
          data: data4,
          options: {}
        };

        const myChart4 = new Chart(
          document.getElementById('myChart4'),
          config4
        );*/
        /*
        var cant_salida = $('#cant_salida').text();
        const labels4 = [
          'Salidas',
        ];

        const data4 = {
          labels: labels4,
          datasets: [{
            label: 'Saldias',
            data: [cant_salida],
            backgroundColor: [
              'rgba(54, 162, 235, 0.2)',
            ],
            borderColor: [
              'rgb(54, 162, 235)',
            ],
            borderWidth: 1
          }]
        };


        const config4 = {
          type: 'bar',
          data: data4,
          options: {
            scales: {
              y: {
                beginAtZero: true
              }
            }
          },
        };

        const myChart4 = new Chart(
          document.getElementById('myChart4'),
          config4
        );

        var cant_ingreso = $('#cant_ingreso').text();
        const labels5 = [
          'Ingresos',
        ];

        const data5 = {
          labels: labels5,
          datasets: [{
            label: 'Ingresos',
            data: [cant_ingreso],
            backgroundColor: [
              'rgba(75, 192, 192, 0.2)',
              'rgba(54, 162, 235, 0.2)'
            ],
            borderColor: [
              'rgb(75, 192, 192)',
              'rgb(54, 162, 235)'
            ],
            borderWidth: 1
          }]
        };


        const config5 = {
          type: 'bar',
          data: data5,
          options: {
            scales: {
              y: {
                beginAtZero: true
              }
            }
          },
        };

        const myChart5 = new Chart(
          document.getElementById('myChart5'),
          config5
        );
   */

} ); //Final

